/**
 * @file 号码认证
 * @author wence
 */

import {rcAjax} from '../util';
import {
    GET_NUMBER_COMMON_LIST,
    GET_NUMBER_COMMON_INFO,
    GET_NUMBER_SEARCH_RESULT
} from './ActionTypes';
import qs from 'query-string';

let isGetProsition = false;
export function getNumberCommonList() {
    return function (dispatch) {
        return rcAjax('GET', '/xiapi/api/v1/phone/phoneList', {}, {}, data => {
            return dispatch({type: GET_NUMBER_COMMON_LIST, data: data.data && data.data.data || []});
        });
    };
}

export function getNumberCommonInfo(id) {
    return function (dispatch) {
        return rcAjax('GET', '/xiapi/api/v1/phone/phoneDetail', {id}, {}, data => {
            return dispatch({type: GET_NUMBER_COMMON_INFO, data: data.data && data.data.data || []});
        });
    };
}

export function getNumberSearchResult({isMore, ...params}) {
    return function (dispatch, getState) {
        if (!isGetProsition && !params.position) {
            return getGeoloaction().then(position => {
                isGetProsition = true;
                return fetchPhoneQuery({...params, position}, dispatch, getState, isMore);
            });
        }

        return fetchPhoneQuery(params, dispatch, getState, isMore);
    };
}

export function fetchPhoneQuery(params, dispatch, getState, isMore) {
    const localKey = '__abbaidu_20181211_cb';
    let localData = {};
    try {
        if (window.localStorage) {
            localData = JSON.parse(window.localStorage.getItem(localKey)) || {};
        }
    }
    catch (e) {
        localData = {};
    }

    if (localData.data) {
        params.data = localData.data;
    }
    if (localData.key_id) {
        params.key_id = localData.key_id;
    }
    if (localData.sign) {
        params.sign = localData.sign;
    }

    return rcAjax('POST',
        '/xiapi/api/v1/phone/query',
        {},
        qs.stringify(params),
        data => {
            const numberSearchResult = getState().numberSearchResult;
            const curData = data.data && data.data.data || {};
            const isAuthKey = 'is_auth';

            if (curData.is_auth === 'login') {
                window.location.href = `/m/login/${location.href}`;
                return;
            }

            if (curData.is_auth === 'bot') {
                return dispatch({
                    type: GET_NUMBER_SEARCH_RESULT,
                    data: {list: [], [isAuthKey]: 'bot'},
                    status: data.data.status,
                    params
                });
            }

            if (curData.list && isMore) {
                curData.list = [...numberSearchResult.list, ...curData.list];
            }
            return dispatch({
                type: GET_NUMBER_SEARCH_RESULT,
                data: curData,
                status: data.data.status,
                params
            });
        });
}

export function getGeoloaction() {
    return new Promise(resolve => {
        if (window.BMap) {
            setTimeout(() => {
                let position = '';
                // if (window.localStorage) {
                //     try {
                //         position = window.localStorage.getItem('position') || '';
                //     }
                //     catch (e) {
                //         position = '';
                //     }
                // }
                resolve(position);
            }, 5000);
            const geolocation = new window.BMap.Geolocation();
            geolocation.getCurrentPosition(function (res) {
                if (this.getStatus() === 0) {
                    const position = res.point.lat + '|' + res.point.lng;

                    if (window.localStorage) {
                        window.localStorage.setItem('position', position);
                    }
                    resolve(position);
                }
                else {
                    resolve('');
                }
            }, {enableHighAccuracy: true});
        }
        else {
            resolve('');
        }
    });
}



// WEBPACK FOOTER //
// ./src/actions/numberAuthAction.js